const state = {
  'dark-theme': {
    '--main-color':  '#1A1F6D',
    '--summary-panel-border-color': 'var(--main-color)',
    '--panel-bar-bg-color': 'var(--main-color)',
    '--white-color': '#FFFFFF',
    '--black-color': '#000000',
    '--main-title-color': 'var(--white-color)',
    '--header-right-label-color': 'var(--white-color)',
    '--dashboard-bg-color': '#090C23',
    '--dashboard-color': 'var(--white-color)',
    '--panel-body-bg-color': '#0B0F28',
    '--summary-panel-bg-color' :'linear-gradient(to bottom, var(--main-color), #0B0F28)',
    '--summary-panel-bg-title-color': 'var(--white-color)',
    '--v-icon-color': 'var(--white-color)',
    '--tr-even-gradient-color-1': '#111548',
    '--tr-even-gradient-color-2': '#090C24',
    '--tr-odd-gradient-color': '',
    '--period-box-bg-color': '#0A0C22',
    '--period-box-menu-bg-color': '#3A3C4E',
    '--bar-chart-gradient': '#EEEE07',
    '--instagram-bg-color': '#0A0C23',
    '--instagram-title-color': 'var(--white-color)',
    '--chart-area-bg-color': '#1A1F6F',
    '--chart-area-border-color': '#1A1F6F',
    '--instagram-tr-even-gradient-color-1': '#111548',
    '--line-chart-tooltip-border-color': '#333',
    '--line-chart-tooltip-bg-color': 'rgba(0,0,0,0.8)',
    '--line-chart-tooltip-title-color': 'var(--main-title-color)',
    '--line-chart-y-color': '#8D8C8E',
    '--line-chart-y-curve-color': '#00CBFF',
    '--left-area-item-odd-gradient-1': '#1A1F6F',
    '--left-area-item-odd-gradient-2': '#111548',
    '--symbol-details-button-bg-color': '#009AD4',
    '--symbol-details-button-text-color': 'var(--white-color)',
    '--symbol-details-button-hover-color': '#9A9D9E',
    '--right-info-color': 'var(--main-color)',
    '--multiple-selection-item-color': 'var(--white-color)'
  },
  'light-theme': {
    '--main-color':  '#1A1F6D',
    '--summary-panel-border-color': 'AD',
    '--panel-bar-bg-color': 'var(--main-color)',
    '--white-color': '#FFFFFF',
    '--black-color': '#000000',
    '--main-title-color': '#1A206D',
    '--header-right-label-color': 'rgb(80, 84, 142)',
    '--dashboard-bg-color': '#F1F1F1',
    '--dashboard-color': '',
    '--panel-body-bg-color': '#F0F0F0',
    '--summary-panel-bg-color': 'linear-gradient(to bottom, #DCDCE7, var(--white-color))',
    '--summary-panel-bg-title-color': 'var(--main-color)',
    '--v-icon-color': '',
    '--tr-even-gradient-color-1': '#E1E1EB',
    '--tr-even-gradient-color-2': 'var(--white-color)',
    '--tr-odd-gradient-color': 'var(--white-color)',
    '--period-box-bg-color': 'var(--main-color)',
    '--period-box-menu-bg-color': '#484C8A',
    '--bar-chart-gradient': '#EEEE07',
    '--instagram-bg-color': '#F0F0F0',
    '--instagram-title-color': '#1A1F6F',
    '--chart-area-bg-color': 'var(--white-color)',
    '--chart-area-border-color': '#1A1F6F',
    '--instagram-tr-even-gradient-color-1': '#F0F0F0',
    '--line-chart-tooltip-border-color': '#DDD',
    '--line-chart-tooltip-bg-color': 'rgba(255,255,255,0.9)',
    '--line-chart-tooltip-title-color': 'var(--main-title-color)',
    '--line-chart-y-color': '#D4D2D6',
    '--line-chart-y-curve-color': '#00CBFF',
    '--left-area-item-odd-gradient-1': '#1A1F6F',
    '--left-area-item-odd-gradient-2': '#111548',
    '--symbol-details-button-bg-color': '#009AD4',
    '--symbol-details-button-text-color': 'var(--white-color)',
    '--symbol-details-button-hover-color': '#9A9D9E',
    '--right-info-color': 'var(--main-color)',
    '--multiple-selection-item-color': 'var(--black-color)'
  }
};

export default {
  namespaced: true,
  state
};
